export const successMessages: Record<string, string> = {
  EmailContributors: 'Contributor report emailed.',
  GenerateOrganizationAuditReport: 'Organization Audit report emailed.',
  GenerateOrganizationSecurityReport: 'Organization Security report emailed.',
  GenerateCSVExport: 'Global Issue CSV Export report emailed.',
  GenerateCSVIssue: 'Selected Issues CSV report emailed.',
  GenerateRevisionReport: 'Report emailed',
  ExportIssueSnapshots: 'Issue Overview export report emailed.',
  GeneratePackageIndexExport: 'Package Inventory export report emailed.',
  GenerateOrganizationBomReportTwo: 'Global Package Report Bundle report emailed.',
  GenerateCSVAuditLogs: 'Audit logs export emailed.',
  ProjectRevisionShare: 'Project shared successfully.',
  HostedAutomatedBuild: 'Revision rebuilt successfully. Analyzing your dependencies...',
  HostedAutomatedBuildParseHubbleResult: 'Revision rebuilt successfully. Analyzing your dependencies...',
};

export const failureMessages: Record<string, string> = {
  EmailContributors: 'Contributor report failed.',
  GenerateOrganizationAuditReport: 'Global Audit report failed.',
  GenerateOrganizationSecurityReport: 'Global Security report failed.',
  GenerateCSVExport: 'Global Issue CSV Export report failed.',
  GenerateCSVIssue: 'Selected Issues CSV report failed.',
  GenerateRevisionReport: 'Building report failed.',
  ExportIssueSnapshots: 'Issue Overview export report failed.',
  GeneratePackageIndexExport: 'Package Inventory export report failed.',
  GenerateOrganizationBomReportTwo: 'Global Package Report Bundle report failed.',
  GenerateCSVAuditLogs: 'Audit logs export failed.',
  ProjectRevisionShare: 'Project share request failed.',
  HostedAutomatedBuild: 'Revision rebuild failed.',
  HostedAutomatedBuildParseHubbleResult: 'Revision rebuild failed.',
};
